import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { bsc } from "@reown/appkit/networks";

const projectId = import.meta.env.VITE_REOWN_PROJECT_ID;

if (!projectId) {
  console.warn("Missing VITE_REOWN_PROJECT_ID");
}

const metadata = {
  name: "Donation Wallet",
  description: "Community donation page for a friend in need",
  url: window.location.origin,
  icons: [`${window.location.origin}/vite.svg`],
};

export const appKitModal = createAppKit({
  adapters: [new EthersAdapter()],
  networks: [bsc],
  defaultNetwork: bsc,
  metadata,
  projectId,
  features: {
    analytics: false,
  },
});
